import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { MessengerService } from '../messenger/messenger.service';
import { CommunicationInterfaceService } from '../communicationInterface/communication-interface.service';
import { AppdataService } from '../app-data/appdata.service';

@Injectable({
  providedIn: 'root'
})
export class ChatqueueService {
  queuePos: number;
  inQueue: boolean = false;
  isQueueAudioPlaying: boolean = false;
  isRemoteUserConnected: boolean = false;
  Headers: any[] = [];
  Footers: any[] = [];

  private queuePosText = new BehaviorSubject<any>({ queueText: '', queueNumber: 0 });
  private queuePosNumber = new ReplaySubject<any>(1);

  cast: Observable<any> = this.queuePosText.asObservable();
  queueData: Observable<any> = this.queuePosNumber.asObservable();

  private toggleQueue = new Subject<any>();
  toggleQueueObservable: Observable<any> = this.toggleQueue.asObservable();
  
  updateQueueVideo = new Subject<any>();
  observeUpdateQueueVideo: Observable<any> = this.updateQueueVideo.asObservable();

  queueVideo:String;

  constructor(private route: Router, private messengerService: MessengerService, private commInterface: CommunicationInterfaceService, appDataService: AppdataService) {
    console.log('%c ChatqueueService', 'color:white; background: blue;');
    appDataService.appConfigSub.subscribe((config) => {
      if (!config) {
        return;
      }
      this.commInterface.registerCallbackEvents();
    });
    
  }

  updateQueuePostionText(text: string) {
    // update the text only once
    let queueMsg = {
      queueText: text,
      queueNumber: this.queuePos
    };
    console.log(queueMsg);
    this.queuePosText.next(queueMsg);
  }

  updateQueueNumberandImage(queueText: string, queueImg: string, queueNo: string, agentTransferText: any) {
    this.queuePosNumber.next({ queueText, queueImg, queueNo, agentTransferText });
  }

  toggleQueueOverlay(isOpen) {
    this.toggleQueue.next(isOpen);
  }

  setQueueStatus(isInQueue :boolean){
    this.inQueue = isInQueue;
  }

  /**
   * Method to emit queue header and footer events
   * @param header Queue header array
   * @param footer Queue footer array
   */
  updateQueueHF(Headers: any[], Footers: any[]): void {
    try {
      this.Headers = Headers;
      this.Footers = Footers;
    } catch (error) {
      console.error(error)
    }
  }

  /*
  * Method to stop queue audio playing
  */
  stopQueueAudio(): void {
    try {
      if (this.isQueueAudioPlaying) {
        this.commInterface.audio.pause();
        this.commInterface.audio.volume = 0;
        this.commInterface.audio = null;
        this.commInterface.logToServer('info', 'LivechatComponent.stopQueueAudio', 'Stopped queue audio');
      }
    } catch (error) {
      console.error('%c Error Occured in stopQueueAudio', 'color: red', error);
      this.commInterface.sendUIErrors('LivechatComponent', 'stopQueueAudio', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in LivechatComponent.stopQueueAudio',
        JSON.stringify(error)
      );
    }
  }
}
